// External Dependencies:
const uuidv4 = require( 'uuid/v4' )

// Internal Dependencies:
import { get } from 'utilities/objects'

// Cart:
const emptyCart = {
	addedIds: [],
	quantityById: {}
}
let cart = emptyCart

const emptyCompletedCart = {
	addedIds: [],
	quantityById: {}
}
let completedCart = emptyCompletedCart

const localStoreCart = localStorage.getItem( 'cart' )
const localStoreCompletedCart = localStorage.getItem( 'completedCart' )

if ( localStoreCart ) {
	cart = JSON.parse( localStoreCart )
}

if ( localStoreCompletedCart ) {
	completedCart = JSON.parse( localStoreCompletedCart )
}

// Share link:
let shareLinkData = false
const localStoreShareLinkData = localStorage.getItem( 'shareLinkData' )

if ( siteData.share_link_data ) {
	localStorage.setItem( 'shareLinkData', JSON.stringify( siteData.share_link_data ) )
	shareLinkData = siteData.share_link_data
} else if ( localStoreShareLinkData && ! siteData.is_authenticated ) {
	shareLinkData = JSON.parse( localStoreShareLinkData )
}

const initialState = {
	creatingAccount: false,
	createdAccount: false,
	requestedAccountData: false,
	accountData: false,
	salesById: false,

	shareLinkData: shareLinkData,

	errorMessage: '',

	loggedIn: false,
	logInError: false,
	logInIsLoading: false,
	resetPasswordEmailSent: false,
	requestPasswordResetError: false,

	resetPasswordKeyChecking: true,
	resetPasswordKeyValid: false,
	newPasswordError: false,
	newPasswordSuccess: false,
	continueUrl: '',

	acceptInviteKeyChecking: true,
	acceptInviteKeyValid: false,
	acceptInviteLoading: false,
	acceptInviteError: false,
	acceptInviteSuccess: false,
	continueUrl: '',

	isDirty: false,
	saveIsProcessing: null,
	saveIsProcessed: null,
	saveIsUnsuccessful: null,
	saveIsSuccessful: null,
	saveIsFinishing: null,
	saveError: null,

	cart: cart,
	completedCart: completedCart
}

export default function pageReducer( state = initialState, action ) {
	const { payload } = action
	let _,
		_new,
		_new2,
		newState,
		randomId

	switch ( action.type ) {
		// Signup:

		case 'CREATING_ACCOUNT':
			return {
				...state,
				creatingAccount: true
			}

		case 'RECEIVE_ACCOUNT_DATA':
			return {
				...state,
				requestedAccountData: true,
				accountData: payload,
				loggedIn: true
			}

		case 'RECEIVE_USER_TRANSACTIONS':
			return {
				...state,
				salesById: payload
			}

		case 'CREATED_ACCOUNT':
			return {
				...state,
				createdAccount: true,
				creatingAccount: false
			}

		case 'SHOW_SIGNUP_ERROR':
			return {
				...state,
				errorMessage: payload
			}

		// Login:

		case 'LOG_IN_LOADING':
			return {
				...state,
				logInIsLoading: true
			}

		case 'SET_AS_LOGGED_IN':
			return {
				...state,
				loggedIn: true,
				logInError: false,
				logInIsLoading: false
			}

		case 'SET_AS_LOG_IN_ERROR':
			return {
				...state,
				logInError: true,
				logInIsLoading: false
			}

		// Password reset request:

		case 'RESET_PASSWORD_EMAIL_SENT':
			return {
				...state,
				resetPasswordEmailSent: true,
				requestPasswordResetError: false,
				logInIsLoading: false
			}

		case 'RESET_PASSWORD_REQUEST_ERROR':
			return {
				...state,
				requestPasswordResetError: true,
				logInIsLoading: false
			}

		// Password reset:

		case 'CHECK_RESET_PASSWORD_KEY_SUCCESS':
			return {
				...state,
				resetPasswordKeyValid: true,
				resetPasswordKeyChecking: false
			}

		case 'CHECK_RESET_PASSWORD_KEY_ERROR':
			return {
				...state,
				resetPasswordKeyValid: false,
				resetPasswordKeyChecking: false
			}

		case 'SET_NEW_PASSWORD_SUCCESS':
			return {
				...state,
				newPasswordSuccess: true,
				continueUrl: payload
			}

		case 'SET_NEW_PASSWORD_ERROR':
			return {
				...state,
				newPasswordError: true
			}

		// Accept invite:
		case 'CHECK_INVITE_KEY_SUCCESS':
			return {
				...state,
				acceptInviteKeyValid: true,
				acceptInviteKeyChecking: false
			}

		case 'CHECK_INVITE_KEY_ERROR':
			return {
				...state,
				acceptInviteKeyValid: false,
				acceptInviteKeyChecking: false
			}

		case 'SET_ACCEPT_INVITE_LOADING':
			return {
				...state,
				acceptInviteLoading: payload
			}

		case 'SET_ACCEPT_INVITE_SUCCESS':
			return {
				...state,
				acceptInviteSuccess: true,
				continueUrl: payload
			}

		case 'SET_ACCEPT_INVITE_ERROR':
			return {
				...state,
				acceptInviteError: true
			}


		// Save:

		case 'SET_DIRTY_STATE':
			return {
				...state,
				isDirty: payload
			}

		case 'SET_SAVE_PROCESSING':
			return {
				...state,
				saveIsProcessing: true,
				saveIsProcessed: false
			}

		case 'SET_SAVE_PROCESSED':
			return {
				...state,
				saveIsProcessed: true,
				saveIsProcessing: false
			}

		case 'SET_SAVE_SUCCESS':
			return {
				...state,
				isDirty: false,
				saveIsUnsuccessful: false,
				saveIsSuccessful: true
			}

		case 'SET_SAVE_ERROR':
			return {
				...state,
				saveIsSuccessful: false,
				saveIsUnsuccessful: true,
				saveError: payload
			}

		case 'SET_SAVE_FINISHING':
			return {
				...state,
				saveIsFinishing: true
			}

		case 'UNSET_SAVE_PROCESSED':
			return {
				...state,
				saveIsProcessed: false,
				saveIsProcessing: false,
				saveIsSuccessful: null,
				saveIsUnsuccessful: null,
				saveIsFinishing: null,
				saveError: null
			}

		// Cart:

		case 'ADD_ITEM_TO_CART':
			newState = {
				...state.cart,
				quantityById: {
					...state.cart.quantityById,
					[ payload ]: ( state.cart.quantityById[ payload ] || 0 ) + 1
				}
			}

			if ( ! state.cart.addedIds || ! state.cart.addedIds.includes( payload ) ) {
				newState.addedIds = [
					...state.cart.addedIds,
					payload
				]
			}

			localStorage.setItem( 'cart', JSON.stringify( newState ) )

			return {
				...state,
				cart: newState
			}

		case 'REMOVE_ITEM_FROM_CART':
			( { [ payload ]: _, ..._new } = state.cart.quantityById )
			_new2 = state.cart.addedIds.filter( id => id != payload )

			newState = {
				...state.cart,
				quantityById: _new,
				addedIds: _new2
			}

			localStorage.setItem( 'cart', JSON.stringify( newState ) )

			return {
				...state,
				cart: newState
			}

		case 'CHANGE_CART_ITEM_QUANTITY':
			newState = {
				...state.cart,
				quantityById: {
					...state.cart.quantityById,
					[ payload.id ]: payload.quantity
				}
			}

			localStorage.setItem( 'cart', JSON.stringify( newState ) )

			return {
				...state,
				cart: newState
			}

		case 'SET_AS_PAYMENT_COMPLETE':
			_new = {
				...state.cart,
				...payload
			}
			localStorage.setItem( 'completedCart', JSON.stringify( _new ) )
			localStorage.setItem( 'cart', JSON.stringify( emptyCart ) )

			return {
				...state,
				completedCart: _new,
				cart: emptyCart,
				quantityById: {}
			}
	}

	return state
}

export const selectProductsInCartFromCartState = ( state, cart, slug ) => {
	if ( ! cart.addedIds || ! cart.addedIds.length ) {
		return null
	}

	return cart.addedIds.map( id => {
		let item = state.page.productsById[ `id_${id}` ]

		if ( ! item ) {
			return null
		}

		item.quantity = cart.quantityById[ id ]
		let price = parseFloat( item.price )
		let priceTotal = price * item.quantity
		item.price = parseFloat( item.price ).toFixed( 2 )
		item.price_total = priceTotal.toFixed( 2 )

		return item
	} )
}

export const selectProductsInCart = ( state, slug ) => {
	return selectProductsInCartFromCartState( state, state.account.cart, slug )
}

export const selectProductsInCompletedCart = ( state, slug ) => {
	return selectProductsInCartFromCartState( state, state.account.completedCart, slug )
}

export const selectCartTotalFromCartState = ( state, cart, slug ) => {
	let total = 0

	if ( ! cart.addedIds || ! cart.addedIds.length ) {
		return total
	}

	cart.addedIds.map( id => {
		let item = state.page.productsById[ `id_${id}` ]

		if ( ! item ) {
			return
		}

		item.quantity = cart.quantityById[ id ]
		let price = parseFloat( item.price )
		let priceTotal = price * item.quantity

		total += priceTotal
	} )

	return parseFloat( total ).toFixed( 2 )
}

export const selectCartTotal = ( state, slug ) => {
	return selectCartTotalFromCartState( state, state.account.cart, slug )
}

export const selectCompletedCartTotal = ( state, slug ) => {
	return selectCartTotalFromCartState( state, state.account.completedCart, slug )
}



// WEBPACK FOOTER //
// ./redux/reducers/account.jsx